/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payout_SettingsInputs */

const en_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout Settings`)
};

const es_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de pagos`)
};

const fr_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de paiement`)
};

const de_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungseinstellungen`)
};

const ja_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払い設定`)
};

const zh_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提现设置`)
};

const ar_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعدادات الدفع`)
};

const id_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan Pembayaran`)
};

const it_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di Pagamento`)
};

const ru_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки выплат`)
};

const pt_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de Pagamento`)
};

const ko_payout_settings = /** @type {(inputs: Payout_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정산 설정`)
};

/**
* | output |
* | --- |
* | "Payout Settings" |
*
* @param {Payout_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const payout_settings = /** @type {((inputs?: Payout_SettingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payout_SettingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_payout_settings(inputs)
	if (locale === "es") return es_payout_settings(inputs)
	if (locale === "fr") return fr_payout_settings(inputs)
	if (locale === "de") return de_payout_settings(inputs)
	if (locale === "ja") return ja_payout_settings(inputs)
	if (locale === "zh") return zh_payout_settings(inputs)
	if (locale === "ar") return ar_payout_settings(inputs)
	if (locale === "id") return id_payout_settings(inputs)
	if (locale === "it") return it_payout_settings(inputs)
	if (locale === "ru") return ru_payout_settings(inputs)
	if (locale === "pt") return pt_payout_settings(inputs)
	return ko_payout_settings(inputs)
});